export const COUPON_MESSAGES_SPEND_MORE_TO_QUALIFY = 'subtotal must reach a higher amount';
export const SHIPPING_MESSAGES_PICKUP_MESSAGE =
    'Orders placed after 3 p.m will be available the next day.';
export const ANALYTICS_GUEST_EMAIL_OPTIN = 'ANALYTICS_GUEST_EMAIL_OPTIN';
export const shippingAddressFormLabels = {
    FIRST_NAME_LABEL: 'First Name',
    LAST_NAME_LABEL: 'Last Name',
    COMPANY_NAME_LABEL: 'Company Name',
    EMAIL_LABEL: 'Email',
    MILITARY_ADDRESS_TYPES_LABEL: 'APO/FPO/DPO',
    ADDRESS_LINE_ONE_LABEL: 'Street Address',
    ADDRESS_LINE_TWO_LABEL: 'Apt, Suite, Floor',
    ADDRESS_LINE_THREE_LABEL: 'Street Address 3',
    ADDRESS_LINE_TWO_LABEL_ALT: 'Street Address 2',
    ADDRESS_LINE_TWO_BUTTON_LABEL: 'Add Street Address 2 (Optional)',
    ADDRESS_LINE_THREE_BUTTON_LABEL: 'Add Street Address 3 (Optional)',
    ADDRESS_LINE_ONE_PLACEHOLDER: 'Enter your address',
    ZIPCODE_LABEL: 'Zip Code',
    ZIPCODE_LABEL_ALT: 'Postal Code',
    PHONE_LABEL: 'Phone Number',
    COUNTRY_LABEL: 'Country',
    ALTERNATE_PHONE_LABEL: 'Alternate Phone Number',
    CITY_LABEL: 'City',
    STATE_LABEL: 'State',
    STATE_LABEL_ALT: 'Province/Territory/Region',
    DELIVERY_INSTRUCTIONS: 'Special Delivery Instructions',
    INSTRUCTIONS_PLACEHOLDER: 'Ex: The building gate code is 5555',
    DEFAULT_TAG: 'Default',
    CONTINUE: 'CONTINUE',
    CONTINUE_TO_PAYMENT: 'Continue to Payment',
    CONTINUE_TO_REVIEW: 'Continue to Review',
    FORM_LABEL_NEW: 'Ship to',
    FORM_LABEL_EDITING: 'Edit Address',
    VIEW_MORE_LABEL: 'View More',
};
export const PRODUCT_ATTRIBUTES_SIZE = 'SIZE';
export const PRODUCT_ATTRIBUTES_SIZE_RANGE = 'SIZE RANGE';
export const PRODUCT_ATTRIBUTES_COMBINED_SIZE = 'COMBINED_SIZE';
export const PRODUCT_ATTRIBUTES_COLOR = 'COLOR';
export const TRUCABLE_PRODUCT_CONSTANTS_TRUCK_DELIVERY_LABEL = 'Truck Delivery';
export const TRUCABLE_PRODUCT_CONSTANTS_TRUCK_DELIVERY_FEE_LABEL = 'Delivery fee may apply';
export const TRUCABLE_PRODUCT_CONSTANTS_EST_DELIVERY_TEXT = 'Est. Delivery:';
export const protectionPlanTypes = ['SERVICE', 'REGULAR'];
export const paymentMethodIconMap = {
    AMEX: 'american-express.svg',
    AMERICANEXPRESS: 'american-express.svg',
    DISCOVER: 'discover.svg',
    GIFTCARD: 'giftcard.svg',
    JCPMASTER: 'dual-black.png',
    JCPENNEYMASTERCARD: 'dual-black.png',
    JCP: 'jcp-black.png',
    MASTER: 'mastercard.svg',
    MASTERCARD: 'mastercard.svg',
    PAYPAL: 'paypal.svg',
    VISA: 'visa.svg',
    APPLEPAY: 'applepay.svg',
    BNPL_SYF: 'bnpl.svg',
};
export const CREAT_ACCOUNT_TITILE_SUCCESS = 'Account created';
export const CREAT_ACCOUNT_TITILE_ERROR = 'Oops! Something went wrong.';
export const CREAT_ACCOUNT_TITILE_INFORMATION = 'Express Checkout failed';
export const CREATE_ACCOUNT_MESSAGE_CATEGOR_SUCCESS = 'success';
export const CREATE_ACCOUNT_MESSAGE_CATEGOR_ERROR = 'error';
export const CREATE_ACCOUNT_MESSAGE_CATEGOR_INFORMATION = 'information';
export const LEARN_MORE = 'Learn More';
export const SHIPPING_GROUP_TITLE_BOPIS = 'Same Day Pickup';
export const SHIPPING_GROUP_TITLE_SHIPPING = 'Shipping';
export const CHECKOUT_ACCORDION_TITLE_SDPU = 'Same Day Pickup';
export const CHECKOUT_ACCORDION_TITLE_SHIPPING = 'Shipping';
export const CHECKOUT_ACCORDION_TITLE_PAYMENT = 'Payment';
export const SHIPPING_GROUP_TYPE_HOME = 'HOME';
export const SHIPPING_GROUP_TYPE_BOPIS = 'BOPIS';
export const SHIPPING_GROUP_TYPE_STORE = 'STORE';
export const shippingDeliveryType = {
    STANDARD: 'Standard',
    GROUND3DAY: '3-Day',
    EXPRESS_ECONOMY: '2-Day',
    EXPRESS: '1-Day',
    TRUCK: 'Truck',
    WILLCALL: 'Will Call',
};
export const ADJUSTMENT_TYPE_COUPON = 'COUPON';
export const ADJUSTMENT_TYPE_ENTERPRISE = 'ENTERPRISE';
export const ADJUSTMENT_TYPE_REWARD = 'REWARDSCERT';
export const ADJUSTMENT_TYPE_FREE_SHIP = 'CouponSHFree';
export const ADJUSTMENT_TYPE_ASSOC_DISCOUNT = 'ASSOCIATEDISCOUNT';
export const ADJUSTMENT_TYPE_SHIPPING = 'SHIPPING';
export const ADJUSTMENT_TYPE_NEW_CUSTOMER = 'NEWCUSTOMER';
export const ADJUSTMENT_TYPE_RESTRICTED = 'RESTRICTED';
export const CHARGE_TYPE_SHIPPING_AND_HANDLING = 'SHIPPING AND HANDLING';
export const CHARGE_TYPE_RETAIL_DELIVERY_FEE = 'RETAIL DELIVERY FEE';
export const CHARGE_TYPE_SHIPTOSTORE = 'SHIP TO STORE';
export const CHARGE_TYPE_SHIPTOHOME = 'SHIP TO HOME';
export const PRODUCT_TYPE_LARGE_APP = 'LARGEAPPLIANCE';
export const FEE_TYPES_RECYCLE = 'Recycle';
export const PICKUP_PERSON = 'Pickup Person';
export const ALTERNATE_PHONE_TITLE = 'Alternate Phone';
export const SPL_DELIVERY_INST_TITLE = 'Special Delivery Instructions';
export const ABOUT_DELIVERY_TITLE = 'About Delivery';
export const ABOUT_DELIVERY_DESC =
    'Our delivery agent will call 24 hours prior to the selected date to provide the delivery window. After delivery, you may be contacted about your satisfaction. All contacts may be automated calls to the number you provided for delivery. ';
export const TRANSACTIONAL_SMS_DATA_TEXT_ORDER_STATUS = ' (text order status)';
export const specialFinancingOfferTitle = 'Selected Special Financing Offer';
export const specialFinancingOfferInformation =
    'This offer will be applied to the portion of your order total that is charged to your JCPenney credit card.';
export const ORDER_TOTAL_NAME_SUBTOTAL = 'Sub total';
export const certonaRecommendationsEmptyCart = true;
export const certonaRecommendationsCart = true;
export const certonaRecommendationsAddToCart = true;
export const ITEMS_TOTALS_NAME_TOTAL_WITHOUT_DISCOUNT = 'TOTALWITHOUTDISCOUNT';
export const itemSurchargeTypes = {
    'OVERSIZE SURCHARGE': {
        code: 'OVERSIZE SURCHARGE',
        description: 'Oversized Item Surcharge',
        TooltipMsg:
            'An oversized item surcharge may apply to some heavy or bulky items due to size, weight or special handling required. This item surcharge is in addition to standard shipping rates.',
    },
    'MONOGRAM SURCHARGE': {
        code: 'MONOGRAM SURCHARGE',
        description: 'Monogram Item Surcharge',
    },
    ITEM_SURCHARGE_TYPES: {
        'OVERSIZE SURCHARGE': {
            code: 'OVERSIZE SURCHARGE',
            description: 'Oversized Item Surcharge',
        },
        'MONOGRAM SURCHARGE': {
            code: 'MONOGRAM SURCHARGE',
            description: 'Monogram Item Surcharge',
        },
    },
};
export const ORDER_QUANTITY_CHANGE_WARNING = 'Available quantity has changed please review';
export const EMPTY_CART_CART_IS_EMPTY = 'Your Cart is Empty';
export const EMPTY_CART_VIEW_COUPONS = "View Today's Coupons";
export const EMPTY_CART_START_SHPNG = 'Start Shopping';
export const SINGLE_CLICK_CHECKOUT_NEED_TO_MAKE_CHANGE = 'View/Edit Order Details';
export const SINGLE_CLICK_CHECKOUT_INCLUDES_TAX = 'Includes tax';
export const SINGLE_CLICK_CHECKOUT_SUBTOTAL = 'Subtotal:';
export const SINGLE_CLICK_CHECKOUT_SUBTOTAL_AFTER_DISCOUNT = 'Subtotal after discounts:';
export const SINGLE_CLICK_CHECKOUT_TOTAL = 'Total';
export const SINGLE_CLICK_CHECKOUT_ORDER_SUMMARY_CHEVRON = 'orderSummaryChevron';
export const LARGE_APPLIANCE_INSTALL_TYPE = 'LARGEAPPLIANCEINSTALL';
export const CURRENCY_US = 'USD';
export const MAXALLOWEDGIFTCARD = 2;
export const CLEARANCECOUPON = 'CLEARANCE';
export const DEVICE_ACCNO = 'Device Account Number';
export const ANALYTICS_AVAILABLE = 'available';
export const ANALYTICS_AVAILABLE_CAPS = 'AVAILABLE';
export const ANALYTICS_PACKAGE_DEAL = 'package deal';
export const ANALYTICS_PAGE_NAME_CART_GIFTCARD_LANDING = 'gift card balance landing';
export const ANALYTICS_PAGE_NAME_CART_GIFTCARD_SUCCESS = 'gift card balance success';
export const ANALYTICS_PAGE_NAME_CHECKOUT_SHOPPING_CART = 'checkout shopping cart';
export const ANALYTICS_PAGE_NAME_CHECKOUT_SAME_DAY_PICKUP = 'checkout same day pickup';
export const ANALYTICS_PAGE_NAME_CHECKOUT_SHIPPING = 'checkout shipping';
export const ANALYTICS_PAGE_NAME_CHECKOUT_PAYMENT = 'checkout payment';
export const ANALYTICS_PAGE_NAME_CHECKOUT_REVIEW = 'checkout review';
export const ANALYTICS_PAGE_NAME_CHECKOUT_ORDER_CONFIRMATION = 'checkout order confirmation';
export const ANALYTICS_PAGE_NAME_PENDING_ORDER_CONFIRMATION = 'pending order confirmation';
export const ANALYTICS_PAGE_NAME_SINGLE_CLICK_CHECKOUT = 'single click checkout';
export const ANALYTICS_PAGE_TYPE_SHOPPING_CART = 'shopping cart';
export const ANALYTICS_PAGE_TYPE_CHECKOUT = 'checkout';
export const ANALYTICS_PAGE_TYPE_ACCOUNT = 'account';
export const ANALYTICS_VERSION_EMPTY_CART = 'apollo 1 empty cart';
export const ANALYTICS_VERSION_CART = 'apollo 1 cart';
export const ANALYTICS_VERSION_SINGLE_CLICK_CHECKOUT = 'apollo 1 scc';
export const ANALYTICS_VERSION_GC_BALANCE = 'apollo 1 gc balance';
export const ANALYTICS_VERSION_CHECKOUT_SIGN = 'apollo 1 checkout sign in';
export const ANALYTICS_VERSION_SDPU = 'apollo 1 sdpu';
export const ANALYTICS_VERSION_SHIPPING = 'apollo 1 shipping';
export const ANALYTICS_VERSION_PAYMENT = 'apollo 1 payment';
export const ANALYTICS_VERSION_REVIEW = 'apollo 1 review';
export const ANALYTICS_VERSION_OCP = 'apollo 1 ocp';
export const ANALYTICS_BEST_COUPON = '-best';
export const ANALYTICS_BOF = '-bof';
export const ANALYTICS_ORIGINAL_KEY = 'ORIGINAL';
export const ANALYTICS_ORIGINAL_VALUE = 'regular';
export const ANALYTICS_CLEARANCE_KEY = 'CLEARANCE';
export const ANALYTICS_CLEARANCE_VALUE = 'clearance';
export const ANALYTICS_SALE_KEY = 'SALE';
export const ANALYTICS_SALE_VALUE = 'sale';
export const ANALYTICS_N_FOR_PRICE_KEY = 'NFORPRICE';
export const ANALYTICS_N_FOR_PRICE_VALUE = 'buy more and save';
export const ANALYTICS_SHIP_TO_HOME_KEY = 'HOME';
export const ANALYTICS_SHIP_TO_HOME_VALUE = 'ship to home';
export const ANALYTICS_STORE_KEY = 'STORE';
export const ANALYTICS_STORE_VALUE = 'ship to store';
export const ANALYTICS_BOPIS_KEY = 'BOPIS';
export const ANALYTICS_BOPIS_VALUE = 'same day pickup';
export const ANALYTICS_BOPIS_ONLY_VALUE = 'same day pickup only';
export const ANALYTICS_SHIP_TO_HOME_OR_STORE_VALUE = 'ship to home or store';
export const ANALYTICS_PRODUCT_AVAILABILITY_ONLINE_ONLY = 'online only';
export const ANALYTICS_PRODUCT_AVAILABILITY_BOTH = 'both';
export const ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL = 'YODA_CART_TOTAL';
export const ANALYTICS_ORDER_UID = 'orderUid';
export const ANALYTICS_CARE_PLAN = 'care plan';
export const ANALYTICS_BUY_MORE_AND_SAVE = 'buy more and save';
export const ANALYTICS_RECYCLE = 'Recycle';
export const ANALYTICS_OVERSIZESURCHARGE = 'OVERSIZE SURCHARGE';
export const ANALYTICS_REWARDSCERT = 'REWARDSCERT';
export const ANALYTICS_ASSOCIATEDISCOUNT = 'ASSOCIATEDISCOUNT';
export const ANALYTICS_ORDERAMOUNT = 'ORDER AMOUNT';
export const ANALYTICS_SUBTOTAL_AFTER_ADJUSTMENT = 'SUB TOTAL AFTER ADJUSTMENT';
export const ANALYTICS_NFORDISCOUNT = 'NFORDISCOUNT';
export const ANALYTICS_SUB_TOTAL = 'SUB TOTAL';
export const ANALYTICS_SHIPPING_AND_HANDLING = 'SHIPPING AND HANDLING';
export const ANALYTICS_COUPON = 'COUPON';
export const ANALYTICS_REWARD_CODE = 'REWARDSCERT';
export const ANALYTICS_YES = 'yes';
export const ANALYTICS_NO = 'no';
export const ANALYTICS_FAIL = 'failed';
export const ANALYTICS_ZERO = '0.00';
export const ANALYTICS_EMPTY = '';
export const ANALYTICS_NO_MARKETING_LABEL = 'no marketing label';
export const ANALYTICS_EXPRESS_CHECKOUT_ELIGIBLE = 'expressCheckoutEligible';
export const ANALYTICS_EXPEDITED_CHECKOUT_ELIGIBLE = 'expediteCheckoutEligible';
export const ANALYTICS_COUPON_DISCOUNT = 'couponDiscount';
export const ANALYTICS_CAREPLAN_DELIVERY_METHOD_MAIL = 'mail';
export const ANALYTICS_CAREPLAN_DELIVERY_METHOD_EMAIL = 'email';
export const ANALYTICS_PAYMENTS_VISA = 'visa';
export const ANALYTICS_PAYMENTS_JCPGIFTCARD = 'giftcard';
export const ANALYTICS_PAYMENTS_PAYPAL = 'paypal';
export const ANALYTICS_PAYMENTS_CC = 'creditcard';
export const ANALYTICS_PAYMENTS_JCP = 'jcp';
export const ANALYTICS_PAYMENTS_APPLEPAY = 'apple pay';
export const ANALYTICS_PAYMENTS_MASTERCARD = 'mastercard';
export const ANALYTICS_PAYMENTS_DISCOVER = 'discover';
export const ANALYTICS_PAYMENTS_AMEX = 'american express';
export const ANALYTICS_PAYMENTS_VERIFIED = 'verified';
export const ANALYTICS_PAYMENTS_MASTER = 'master';
export const ANALYTICS_PAYMENTS_JCPMASTER = 'jcpmaster';
export const ANALYTICS_PAYMENTS_JCPMASTER_VAL = 'jcpenney mastercard';
export const ANALYTICS_PAYMENTS_AMEX_KEY = 'amex';
export const ANALYTICS_APPLY_REWARDS = 'Apply rewards';
export const ANALYTICS_TAX = 'TAX';
export const ANALYTICS_ROUNDUP = 'ROUND UP';
export const ANALYTICS_FREE = 'FREE';
export const ANALYTICS_INSTOCK_KEY = 'instock';
export const ANALYTICS_INSTOCK_VALUE = 'in stock';
export const ANALYTICS_AVAILABLE_LOW_KEY = 'availablelow';
export const ANALYTICS_LIMITED_STOCK_AVAILABLE_KEY = 'limitedstockavailable';
export const ANALYTICS_LIMITED_STOCK_AVAILABLE_VALUE = 'limited stock available';
export const ANALYTICS_LIMITED_QUANTITIES_KEY = 'limitedstockavailable';
export const ANALYTICS_OUT_OF_STOCK_KEY = 'outofstock';
export const ANALYTICS_OUT_OF_STOCK_VALUE = 'out of stock';
export const ANALYTICS_NOT_AVAILABLE_KEY = 'notavailable';
export const ANALYTICS_BACK_ORDER_KEY = 'backordered';
export const ANALYTICS_BACK_ORDER_VALUE = 'backordered';
export const ANALYTICS_DIS_CONTINUED_VALUE = 'discontinued';
export const ANALYTICS_SHIPPING_METHOD = {
    STANDARD: 'standard delivery',
    GROUND3DAY: 'premium delivery 3 business days',
    EXPRESS_ECONOMY: 'express delivery 2 business days',
    EXPRESS: 'expedited delivery 1 business day',
    TRUCK: 'truck delivery',
    BOPIS: 'same day pickup',
};
export const ANALYTICS_SHIPPING_TYPE_GROUND3DAY = 'GROUND3DAY';
export const ANALYTICS_SHIPPING_TYPE_EXPRESS_ECONOMY = 'EXPRESS_ECONOMY';
export const ANALYTICS_SHIPPING_TYPE_EXPRESS = 'EXPRESS';
export const ANALYTICS_PAGE_INFO_CART = 'cart';
export const ANALYTICS_PAGE_INFO_CHECKOUT = 'checkout';
export const ANALYTICS_PAGE_INFO_PAGE_TYPE_CART = 'rewardsorcouponsoncart';
export const ANALYTICS_PAGE_INFO_PAGE_TYPE_CHECKOUT = 'rewardsorcouponsoncheckout';
export const ANALYTICS_ACTIONS_CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const ANALYTICS_ACTIONS_LINK_REWARDS_ACCOUNT = 'LINK_REWARDS_ACCOUNT';
export const ANALYTICS_ACTIONS_UPDATE_CART = 'UPDATE_CART';
export const ANALYTICS_ACTIONS_SAVE_FOR_LATER = 'SAVE_FOR_LATER';
export const ANALYTICS_ACTIONS_REMOVE_ITEM = 'REMOVE_ITEM';
export const ANALYTICS_ACTIONS_MOVE_TO_CART = 'MOVE_TO_CART';
export const ANALYTICS_ACTIONS_SAME_DAY_PICKUP = 'SAME_DAY_PICKUP';
export const ANALYTICS_ACTIONS_PAYPAL_CHECKOUT = 'PAYPAL_CHECKOUT';
export const ANALYTICS_ACTIONS_COUPON_APPLIED_SUCCESS = 'COUPON_APPLIED_SUCCESS';
export const ANALYTICS_ACTIONS_SELECT_STORE_SUCCESS = 'SELECT_STORE_SUCCESS';
export const ANALYTICS_ACTIONS_FIND_COUPON = 'FIND_COUPON';
export const ANALYTICS_ACTIONS_EXPRESS_CHECKOUT = 'EXPRESS_CHECKOUT';
export const ANALYTICS_ACTIONS_EXPEDITED_CHECKOUT = 'EXPEDITED_CHECKOUT';
export const ANALYTICS_ACTIONS_INTERSTITIAL_UPDATE_CART = 'INTERSTITIAL_UPDATE_CART';
export const ANALYTICS_ACTIONS_PRODUCT_CO_OOS = 'PRODUCT_CO_OOS';
export const ANALYTICS_ACTIONS_LOGIN_ATTEMPTED = 'LOGIN_ATTEMPTED';
export const ANALYTICS_ACTIONS_LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const ANALYTICS_ACTIONS_LOGIN_FAILED = 'LOGIN_FAILED';
export const ANALYTICS_ACTIONS_EDIT_CARD_AT_CHECKOUT = 'EDIT_CARD_AT_CHECKOUT';
export const ANALYTICS_ACTIONS_DELETE_CARD_AT_CHECKOUT = 'DELETE_CARD_AT_CHECKOUT';
export const ANALYTICS_ACTIONS_VIEW_FINANCE_OFFER_MODAL = 'VIEW_FINANCE_OFFER_MODAL';
export const ANALYTICS_ACTIONS_ACCEPT_FINANCE_OFFER_MODAL = 'ACCEPT_FINANCE_OFFER_MODAL';
export const ANALYTICS_ACTIONS_PLCC_DYN_BANNER_GET_DETAIL = 'PLCC_DYN_BANNER_GET_DETAIL';
export const ANALYTICS_ACTIONS_CAPTCHA_ERROR = 'CAPTCHA_ERROR';
export const ANALYTICS_ACTIONS_APPLE_PAY_CHECKOUT = 'APPLE_PAY_CHECKOUT';
export const ANALYTICS_ACTIONS_CART_ADD = 'CART_ADD';
export const ANALYTICS_ACTIONS_PAYPAL_STEP_CHECKOUT = 'PAYPAL_STEP_CHECKOUT';
export const ANALYTICS_ACTIONS_COUPON_REMOVED = 'COUPON_REMOVED';
export const ANALYTICS_ACTIONS_OPTIONAL_SERVICE_UPDATE_CART = 'OPTIONAL_SERVICE_UPDATE_CART';
export const ANALYTICS_ACTIONS_OPTIONAL_SERVICE_ADD_CART = 'OPTIONAL_SERVICE_ADD_CART';
export const ANALYTICS_ACTIONS_OPTIONAL_SERVICE_REMOVE_CART = 'OPTIONAL_SERVICE_REMOVE_CART';
export const ANALYTICS_ACTIONS_APP_WALLET_GIFT_CARD_APPLY = 'APP_WALLET_GIFT_CARD_APPLY';
export const ANALYTICS_EVENTS = {
    CREATE_ACCOUNT: 'accountRegistration',
    LINK_REWARDS_ACCOUNT: 'linkRewardsAccount',
    UPDATE_CART: 'cartUpdate',
    SAVE_FOR_LATER: 'saveProductInCart',
    REMOVE_ITEM: 'cartUpdate',
    MOVE_TO_CART: 'moveSavedProductToCart',
    SAME_DAY_PICKUP: 'sameDayPickup',
    PAYPAL_CHECKOUT: 'paypalCheckout',
    COUPON_APPLIED_SUCCESS: 'couponApplied',
    SELECT_STORE_SUCCESS: 'selectStore',
    FIND_COUPON: 'findCoupon',
    EXPRESS_CHECKOUT: 'expressCheckout',
    EXPEDITED_CHECKOUT: 'expeditedCheckout',
    INTERSTITIAL_UPDATE_CART: 'cartUpdate',
    PRODUCT_CO_OOS: 'productCheckoutOOS',
    LOGIN_ATTEMPTED: 'loginAttempted',
    LOGIN_SUCCESS: 'loginSuccess',
    LOGIN_FAILED: 'loginFailed',
    EDIT_CARD_AT_CHECKOUT: 'modifyCreditCardAtCheckout',
    DELETE_CARD_AT_CHECKOUT: 'modifyCreditCardAtCheckout',
    VIEW_FINANCE_OFFER_MODAL: 'financeOfferView',
    ACCEPT_FINANCE_OFFER_MODAL: 'financeOfferAccept',
    PLCC_DYN_BANNER_GET_DETAIL: 'getDetailPlccSlideOver',
    CAPTCHA_ERROR: 'captchaImpression',
    APPLE_PAY_CHECKOUT: 'applePayCheckout',
    GIFT_CARD_BANNER: 'giftCardBanner',
    CART_ADD: 'cartAdd',
    CROSSSELL_CART_ADD: 'cartAdd',
    PAYPAL_STEP_CHECKOUT: 'paypalStepCheckout',
    COUPON_REMOVED: 'couponRemoved',
    OPTIONAL_SERVICE: 'optionalServicesCart',
    ADDITIONAL_PROTECTION_PLAN: 'additionalProtectionCart',
    OPTIONAL_SERVICE_UPDATE_CART: 'cartUpdate',
    OPTIONAL_SERVICE_REMOVE_CART: 'cartUpdate',
    OPTIONAL_SERVICE_ADD_CART: 'cartAdd',
    APP_WALLET_GIFT_CARD_APPLY: 'applygiftcardfromwallet',
    PLCC_APPLY_NOW_LINK: 'plccapplynowlink',
    PLCC_GET_DETAILS: 'plccgetdetails',
};
export const ANALYTICS_CHECKOUT_BTN_POSN_NONSTICKY = 'primary-main';
export const ANALYTICS_CHECKOUT_BTN_POSN_STICKY = 'secondary-sticky';
export const ANALYTICS_CO_PROCESS_TYPE_GUEST = 'guest';
export const ANALYTICS_CO_PROCESS_TYPE_REGISTERED = 'standard';
export const ANALYTICS_CO_PROCESS_TYPE_EXPEDITED = 'expedited';
export const ANALYTICS_CO_PROCESS_TYPE_EXPRESS = 'express';
export const ANALYTICS_CO_PROCESS_TYPE_PAYPAL = 'paypal';
export const ANALYTICS_CO_PROCESS_TYPE_APPLE_PAY = 'apple pay';
export const ANALYTICS_CO_PROCESS_TYPE_SINGLE_CLICK = 'single click';
export const ANALYTICS_CO_PROCESS_TYPE_PAYPAL_EXPRESS = 'paypal express';
export const PAYMENT_METHOD_CREDIT_CARD = 'creditCard';
export const BASE_OFFER_LABEL_CLEARANCE = 'CLEARANCE';
export const BASE_OFFER_LABEL_ORIGINAL = 'ORIGINAL';
export const BASE_OFFER_LABEL_SALE = 'SALE';
export const BASE_OFFER_LABEL_DEFAULT = 'DEFAULT';
export const BASE_OFFER_LABEL_PACKAGE_DEAL = 'Package Deal';
export const BASE_OFFER_LABEL_N_FOR_PRICE = 'NFORPRICE';
export const BASE_OFFER_LABEL_BXGX_PRICE = 'ITEM_PRICE';
export const BASE_OFFER_LABEL_BOPIS_INCENTIVE = 'BOPISINCENTIVE';
export const BASE_PRICE_LABEL_N_FOR = 'NFORDISCOUNT';
export const BASE_PRICE_LABEL_BOPIS_INCENTIVE = 'BOPISINCENTIVE';
export const estDeliveryLabel = 'Est. Delivery:';
export const getIt = 'Get it';
export const COUPON_SUB_TYPE_PROMOTIONAL = 'PROMOTIONAL';
export const InventoryStatus = {
    INSTOCK: {
        status: 'INSTOCK',
        displayDesc: '',
    },
    OUTOFSTOCK: {
        status: 'OUTOFSTOCK',
        desc: 'Out of Stock',
        styleClass: 'outOfStock',
    },
    NOTAVAILABLE: {
        status: 'OUTOFSTOCK',
        desc: 'Out of Stock',
        styleClass: 'outOfStock',
    },
    LIMITEDSTOCKAVAILABLE: {
        status: 'LIMITEDSTOCKAVAILABLE',
        desc: 'Low Stock',
        styleClass: 'lowStock',
    },
    BACKORDERED: {
        status: 'BACKORDERED',
        desc: '',
    },
    OUTOFSTOCKONLINE: {
        status: 'OUT OF STOCK ONLINE',
        desc: 'Out of Stock',
        styleClass: 'outOfStock',
    },
    LIMITEDQUANTITY: {
        status: 'LIMITED QUANTITY',
        desc: 'Low Stock',
        styleClass: 'lowStock',
    },
    DISCONTINUED: {
        status: 'DISCONTINUED',
        desc: 'Discontinued',
        styleClass: 'outOfStock',
    },
};
export const ValidInventoryStatusList = ['limited quantity', 'out of stock online'];
export const GIFT_REGISTRY_MESSAGE = 'address hidden for security';
export const PDP_URL_CONFIG_URL_PARAMETERS_INDEX = 1;
export const URL_CART_PAGE = '/cart';
export const URL_SIGN_IN_PAGE = '/cart/signin';
export const URL_RESET_PASSWORD_PAGE = '/cart/resetpassword';
export const URL_CHECKOUT_PAGE = '/checkout';
export const URL_REVIEW_PAGE = '/checkout/review';
export const URL_CONFIRMATION_PAGE = '/checkout/oc';
export const URL_PAYMENT_PAGE = 'Payment';
export const URL_SHIPPING_PAGE = 'Shipping';
export const URL_HOME_PAGE = '/';
export const URL_CHECKOUT_SHIPPING = '/checkout/shipping';
export const URL_CHECKOUT_PAYMENT = '/checkout/payment';
export const URL_B2B_VOUCHER_PENDING_ORDER = '/b2b/pending-orders?refresh=true';
export const URL_CHECKOUT_BOPIS = '/checkout/bopis';
export const JCP_HOSTNAME_MOBILE = 'm.jcpenney.com';
export const JCP_HOSTNAME_DESKTOP = 'www.jcpenney.com';
export const JCP_HOSTNAME_UNIFIED = 'www-prod.jcpenney.com';
export const PAYPAL_URL_TEST = 'https://www.sandbox.paypal.com/checkoutnow?token=';
export const PAYPAL_URL_PROD = 'https://www.paypal.com/checkoutnow?token=';
export const PAYPAL_FORCE_WEB = '&&force_web=true';
export const PAYPAL_STRATEGY_TYPE_NORMAL = 'paypal-normal';
export const PAYPAL_STRATEGY_TYPE_EXPRESS = 'paypal-express';
export const PAYPAL_STRATEGY_TYPE_PAYPAL = 'paypal';
export const PAY_PAYPAL =
    "Pay with PayPal. You'll return back to JCPenney to review your order before purchase.";
export const X_COMMAND_CHECKOUT = 'initiate-checkout';
export const X_COMMAND_PAYPAL_CHECKOUT = 'initiate-paypal-checkout';
export const DP_REWARDS_STATUS = 'DP_REWARDS_STATUS';
export const OC_ACCOUNT_CREATION_NOTE =
    "We've saved your information, sign up by simply entering a phone number & password for";
export const OFFERING_CONSTANTS_MAIN_TITLE = 'Select Parts & Services';
export const OFFERING_CONSTANTS_INSTALL_TITLE = 'Required installation parts';
export const OFFERING_CONSTANTS_INSTALL_TITLE_MSG =
    'Would you like us to install your appliance for';
export const OFFERING_CONSTANTS_SERVICE_TITLE = 'Additional Services';
export const OFFERING_CONSTANTS_NO_SERVICE_MSG = 'No additional services are available.';
export const OFFERING_CONSTANTS_CARE_PLAN_TITLE = 'Additional Protection';
export const OFFERING_CONSTANTS_CARE_PLAN_SUB_TITLE =
    'Protect your investment beyond the terms of your original warranty';
export const OFFERING_CONSTANTS_INSTALLATION = 'Installation';
export const OFFERING_CONSTANTS_OPTIONAL_SERVICE_TITLE = 'Optional Services';
export const OFFERING_TYPES_INSTALLATION = 'installation';
export const OFFERING_TYPES_OTHER = 'other';
export const OFFERING_TYPES_CARE_PLAN = 'care plan';
export const OFFERING_TYPES_ADDITIONAL_SERVICES = 'additionalServices';
export const CREDIT_CARD_FORM_CONFIG_ERROR_MSG_UNKNOWN_TYPE =
    'We did not recognize the "type" of card you entered. Make sure you entered your "card number" correctly.';
export const CREDIT_CARD_FORM_CONFIG_ERROR_MSG_FIELD_REQUIRED = ' ';
export const CREDIT_CARD_FORM_CONFIG_TOOLTIP_MSG =
    'This CVV is the last 3 digits on the back of your JCPenney MasterCard, Visa, MasterCard or Discover card. The security code on American Express cards is the 4 digit number on the front of your card above your account number.';
export const CREDIT_CARD_FORM_CONFIG_TOOLTIP_JCP_CVV_MSG =
    'This CVV is the last 3 digits on the back of your JCPenney Credit Card. If you’re having difficulty finding it, call 1-800-527-4403 for assistance.';
export const CONTENT_API_KEYS_DISPOSABLE_FEE = 'cf-disposal-fee';
export const CONTENT_API_KEYS_RECYCLE_TRUCKABLE_FEE = 'cf-truckable-and-recycle-fee';
export const ORDER_STATUS_DRAFT = 'DRAFT';
export const SUBMITTED_TO_B2B_AGENCY = 'SUBMITTED_TO_B2B_AGENCY';
export const DELETE_SHIPPING_ADDRESS_MSG_HOME_ADDRESS = {
    DELETE_TITLE: 'Cannot Delete',
    DELETE_MSG:
        'This is set as your home address, Your home address cannot deleted. Please edit or add a new address.',
    CONFIRM_BTN_LABLE: 'Edit',
};
export const DELETE_SHIPPING_ADDRESS_MSG_NO_HOME_ADDRESS = {
    DELETE_TITLE: 'Delete Address',
    DELETE_MSG: 'Are you sure you want to delete this address? This cannot be undone',
    CONFIRM_BTN_LABLE: 'Delete',
};
export const SHIPPING_THRESHOLD_MET = "Great! You've earned";
export const SHIPPING_THRESHOLD_NOT_MET_NEW_CART = 'away from';
export const SHIPPING_THRESHOLD_FREE = 'FREE Ship to Home!';
export const NEW_SHIPPING_THRESHOLD_FREE = 'FREE Ship to Home';
export const PATCH_FINANCING_PARAMS_OP = 'replace';
export const PATCH_FINANCING_PARAMS_PATH = '/selected';
export const SHIP_TO_STORE_LABELS_LABEL_CHANGE_STORE = 'Change Store';
export const SHIP_TO_STORE_LABELS_ENTER_CONTACT_INFORMATION = 'Enter Contact Information';
export const SHIP_TO_STORE_LABELS_CONTACT_MESSAGE =
    'We’ll use this information to contact you about your order.';
export const SHIP_TO_STORE_LABELS_STANDARD_DELIVERY_MESSAGE = 'Standard delivery 4-7 business days';
export const SHIP_TO_STORE_LABELS_STANDARD_DELIVERY_MESSAGE_UPDATED = '4-7 business days';
export const SHIP_TO_STORE_LABELS_SHIPPING_METHOD = 'Shipping Method';
export const SILVER_ITEM_INFORMATION_REVIEW_MESSAGE =
    'A delivery agent will call to confirm your delivery window.';
export const DOLLAROFF = 'ABSOLUTE';
export const PERCENTOFF = 'PERCENTAGE';
export const EARNED_REWARDS_WELCOME = 'Welcome, ';
export const EARNED_REWARDS_JCPENNY = 'JCPenney';
export const EARNED_REWARDS_REWARDS_MEMBER = 'Rewards Member';
export const EARNED_REWARDS_REWARDS_LABEL = 'In Rewards';
export const COUPON_ERROR_MESSAGE_COUPON_CODE_MISSING = 'Please enter a coupon or reward code';
export const COUPON_ERROR_MESSAGE_INPUT_BOX_PLACEHOLDER = 'Enter promo code...';
export const COUPON_ERROR_MESSAGE_SERIAL_NUMBER_REQUIRED = 'Serial Number Required';
export const COUPON_ERROR_MESSAGE_SERIAL_NUMBER_REQ_MESSAGE =
    'This code requires a serial number. Please type in the serial number shown on your coupon or reward.';
export const COUPON_ERROR_MESSAGE_COUPON_NO_CART_ITEMS =
    'We can apply this coupon code once you add an item to your bag';
export const COUPON_ERROR_MESSAGE_COUPON_DENIED =
    'One or more items in your cart are not eligible for this code.';
export const COUPON_TYPEAHEAD_TRIGGER_LENGTH = 3;
export const IN_STORE_ONLY_COUPONS = 'INSTOREONLYCOUPONS';
export const COUPON_APPLIED_METHOD_INPUT_COUPON = 'manual';
export const COUPON_APPLIED_METHOD_SELECT_COUPON = 'selected from list';
export const COUPON_APPLIED_SECTION_CART_PAGE = 'CART_PAGE';
export const COUPON_APPLIED_SECTION_COUPON_SLIDER = 'COUPON_SLIDER';
export const COUPON_APPLIED_SECTION_REWARD_SLIDER = 'REWARD_SLIDER';
export const COUPON_APPLIED_SECTION_COUPON_SLIDER_LIST = 'COUPON_SLIDER_LIST';
export const COUPON_APPLIED_SECTION_SERIAL_MODAL = 'SERIAL_MODAL';
export const COUPON_UPDATED_ONE_COUPON_PER_PURCHASE = 'Only one (1) coupon code per purchase.';
export const GENERIC_ERROR_MSG =
    'Oops! there was an error processing your request. Please try again to proceed with your order.';
export const INVALID_GIFTCARD_ERROR_MSG =
    'The gift card you entered is invalid. Please use a different gift card or contact customer service at 800-294-8804.';
export const INVALID_GIFTCARD_CAPTCHA_MSG = 'Captcha is missing or incomplete';
export const TOTAL_EXCEEDED_ERROR_MSG =
    'Your order exceeds $99,999.99, the maximum amount allowed on jcp.com. Please remove item(s) from your bag or move item(s) to your saved items list for later purchase.';
export const EXPOSED_PACKAGING_CHECKOUT_MSG =
    "Item may ship in original packaging, revealing what's inside. Make sure you're shipping to a safe location.";
export const EXPOSED_PACKAGING_CART_MSG = 'Item arrives in original packaging';
export const ACCOUNT_LOCKED_PAGE_TITLE = 'You have been logged out...';
export const ACCOUNT_LOCKED_PAGE_MESSAGE =
    'In order to protect your account we have ended your session due to excessive payment attempts.';
export const ACCOUNT_LOCKED_PAGE_HOME_LINK = 'Return to Home';
export const ACCOUNT_LOCKED = 'accountLocked';
export const OUT_OF_STOCK = 'Out of Stock';
export const OOS_GENERIC_MESSAGE =
    'One or more items have become out of stock, and will be removed from your cart.';
export const OOS_MESSAGE =
    'One or more items have become out of stock, and will be removed if you checkout. You can edit the item to see if other product options are available. Same Day Pick Up items may be available at other stores.';
export const DISCONTINUED_MESSAGE =
    'One or more items are now discontinued and no longer available for purchase.';
export const SFL_OOS_MESSAGE =
    "You can edit this item to see if it's available in other options, or check back with us later to see if this item is back in stock.";
export const RECAPTCHA_SITE_KEY = '6Lf6BAYTAAAAAJ5F7IEbFCirG1uJCBmHS_34jtq7';
export const RECAPTCHA_ERRORCODES_LAST_ATTEMPT = 'SVC_USR_ERR_PROFILE_ACCOUNT_LAST_ATTEMPT';
export const RECAPTCHA_ERRORCODES_NOT_FOUND = 'SRV_INVALID_CAPTCHA_REQUEST';
export const RECAPTCHA_ERRORCODES_INVALID = 'SRV_GC_CAPTCHA_INVALID';
export const CAPTCHA_ENABLED_SIGNIN = true;
export const GENERIC_ERROR_CART_MSG = 'Please refresh the page and try again.';
export const GENERIC_ERROR_CHECKOUT_MSG =
    'Please refresh the page and try again or return to cart.';
export const GENERIC_ERROR_TITLE = "We've encountered a bit of a glitch.";
export const GENERIC_ERROR_REFRESH_BTN_LABLE = 'Refresh';
export const GENERIC_ERROR_CART_BTN_LABLE = 'Return to Cart';
export const GENERIC_ERROR_TOKEN_API_FAILED_MSG = 'Please try again.';
export const GENERIC_ERROR_OK_BTN_LABLE = 'OK';
export const BUNDLE_NAVIGATION = {
    NEXT: 'NEXT',
    PREVIOUS: 'PREVIOUS',
    CHECKOUT: 'CHECKOUT',
    BACK: 'BACK',
};
export const CHECKOUT_URL = '/cart';
export const CHECKOUT_DESKTOP_URL = '/cart';
export const CUSTOMER_SERVICE = 'by calling customer service.';
export const CANCEL_MESSAGE = 'You may cancel your order within';
export const CANCEL_ORDER_URL =
    '/orders/trackorders?CM_MMC=Trans-_-OrderConf-_-GBL-_-CheckOrderStatus&orderNumber=';
export const SERVICE_NUMBER = '1-800-322-1189';
export const HOLIDAY_MESSAGE_CONTENT = 'cf-holiday-message-info';
export const PLCC_BANNER_CONTENT = 'cf-plcc-banner-cart-v1';
export const CURBSIDE_CART_CONTENT = 'cf-curbside-cart';
export const HOLIDAY_BOPIS_CONTENT = 'cf-holidaybopismsg-cart';
export const ROUNDUP_LEARNMORE_CONTENT = 'cf-rounduplearnmore';
export const EMPTY_CART_CONTENT = 'cf-empty-cart';
export const TRUCKABLE_RECYCLE_FEE_CONTENT = 'cf-truckable-and-recycle-fee';
export const REWARDS_BANNER_CONTENT = 'cf-rewards-banner-cart';
export const SHOP_REWARDS_BANNER_CONTENT = 'cf-shop-rewards-banner-cart';
export const CURBSIDE_OCP_CONTENT = 'cf-curbside-ocp';
export const TRUCKABLE_DELIVERY_CONTENT = 'cf-truckable-item-delivery-info';
export const LARGE_APP_TRUCK_DELIVERY_CONTENT = 'cf-large-app-truck-delivery-info';
export const TRANSACTIONAL_SMS_TERMS = 'cf-transactional-sms-termsAndConditions';
export const TRANSACTIONAL_SMS_PRIVACY = 'cf-transactional-sms-privacyNotice';
export const HOLIDAY_BOPIS_MESSAGE_CONTENT = 'cf-holidaybopismsg';
export const CALIFORNIA_HA_MESSAGE_CONTENT = 'cf-californiahaulaway';
export const TOTAL_REDUCED = 'Great News! Your total has reduced to';
export const PAGE_TITLES_CART = 'Cart - JCPenney';
export const PAGE_TITLES_SIGN_IN = 'SignIn - JCPenney';
export const PAGE_TITLES_CHECKOUT = 'Checkout - JCPenney';
export const PAGE_TITLES_REVIEW_ORDER = 'Review Order - JCPenney';
export const PAGE_TITLES_ORDER_CONFIRMATION = 'Order Confirmation - JCPenney';
export const PAGE_TITLES_GIFT_CARD = 'Gift Card - JCPenney';
export const GOOGLE_ADS_CART_PAGE_BOTTOM_LEFT = 'div-gpt-ad-691978983164912457-1';
export const GOOGLE_ADS_OC_PAGE_BOTTOM_LEFT = 'div-gpt-ad-jcpenney_orderconfirm-2';
export const GOOGLE_ADS_OC_PAGE_RIGHT_CENTER = 'div-gpt-ad-jcpenney_orderconfirm-1';
export const GOOGLE_ADS_GIFTCARD_PAGE_BOTTOM = 'div-gpt-ad-jcpenney_gift_card-1';
export const PLCC_DYN_BANNER_CODES = [
    'PROMOFINANCE',
    'APPLYANDBUY',
    'EMPTYCART',
    'SAVEDCARDPROMOFINANCEBANNER',
];
export const PLCC_DYN_BANNER_APPLY_AND_BUY_CODE = 'APPLYANDBUY';
export const PLCC_DYN_BANNER_EMPTY_CART_CODE = 'EMPTYCART';
export const PLCC_DYN_BANNER_PROMO_FINANCE_CODE = 'PROMOFINANCE';
export const PLCC_DYN_BANNER_SAVED_CARD_PROMOFINANCE_CODE = 'SAVEDCARDPROMOFINANCEBANNER';
export const PLCC_CREDIT_UPSELL_VIEWS = 'plcccreditupsellviews';
export const DELIVERY_CHANGE_MESSAGE = 'Delivery method for this item has changed.';
export const PLACE_ORDER_GENERIC_ERROR_TITLE =
    'We apologize, but we cannot place your order at this time';
export const PLACE_ORDER_GENERIC_ERROR_MESSAGE =
    'If you would like to continue with this order, please call Customer Service at 800-322-1189.';
export const MODAL_ERROR_PREFIX = 'Modal: ';
export const SESSION_ERROR_TITLE = 'Session Expired';
export const SESSION_ERROR_PAYMENT_TITLE = "We can't process this payment";
export const SESSION_ERROR_MESSAGE =
    'For your protection, this session expired due to inactivity. Please try again.';
export const STREET_ERROR_MESSAGE =
    "The street address entered doesn't appear to have a valid house number. Please double-check the information you entered.";
export const CREATE_ACC_SUCCESS_MSG = 'You’ve successfully created a jcp.com account';
export const CAPTCHA_TYPES_INVISIBLE = 'invisible';
export const CAPTCHA_TYPES_VISIBLE = 'visible';
export const IRIS_MARKETING_SLOT = {
    xlarge: 'desktop',
    large: 'tablet',
    medium: 'tablet',
    small: 'mobile',
};
export const CUSTOM_ERR_MSG_MESSAGE =
    'Your account has been locked. Check your email for instructions on how to unlock it, or click <a href="/forgotpassword">here</a> to reset your password.';
export const CUSTOM_ERR_MSG_ERROR_CODE = 'SVC_USR_ERR_RESET_PASSWORD_REQUIRED';
export const REWARD_PROMO_FINANCE_CONFLICT = 'REWARD_PROMO_FINANCE_CONFLICT';
export const REWARD_PROMO_FINANCE_ELIGIBLE = 'REWARD_PROMO_FINANCE_ELIGIBLE';
export const REWARD_CATEGORY = 'NEWCUSTOMER';
export const PROMOFINANCE_OPTION_TYPE = 'PROMO_FINANCE';
export const REWARD_OPTION_TYPE = 'NEW_CUSTOMER_REWARD';
export const ORDER_REVIEW_ERROR_SUBCODE = 'ORDER_REVIEW';
export const APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE =
    'USE A JCPENNEY CARD TO GET THE BEST DISCOUNT FOR';
export const APPLE_PAY_REQUEST_TEMPLATE = {
    countryCode: 'US',
    currencyCode: 'USD',
    supportedNetworks: ['visa', 'mastercard', 'discover', 'amex'],
    requiredShippingContactFields: ['postalAddress', 'name', 'phone', 'email'],
    requiredBillingContactFields: ['postalAddress', 'name', 'phone', 'email'],
    merchantCapabilities: ['supports3DS'],
    total: {
        label: 'TOTAL',
        amount: 1,
        type: 'pending',
    },
};
export const APPLEPAY_ERROR_CONTACT_FIELD_NAME = {
    contactField: 'name',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_ADDRESS = {
    contactField: 'postalAddress',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_ADDRESS_LINES = {
    contactField: 'addressLines',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_LOCALITY = {
    contactField: 'locality',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_ADMINISTRATIVE_AREA = {
    contactField: 'administrativeArea',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_COUNTRY = {
    contactField: 'country',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_CODE = {
    contactField: 'postalCode',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_CONTACT_FIELD_PHONE_NUMBER = {
    contactField: 'phoneNumber',
    messageOverride: false,
    customErrMsg: '',
};
export const APPLEPAY_ERROR_MAP = {
    DELIVERY_STH: {
        code: 'shippingContactInvalid',
        SRV_CUSTOMER_PHONE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_PHONE_NUMBER,
        SRV_CUSTOMER_STATE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_ADMINISTRATIVE_AREA,
        API_ERR_FIELD_STATE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_ADMINISTRATIVE_AREA,
        SRV_CUSTOMER_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_CODE,
        API_ERR_FIELD_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_CODE,
        SRV_CUSTOMER_STD_CDI002_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_ADDRESS_LINES,
        SRV_CUSTOMER_LASTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        SRV_CUSTOMER_FIRSTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
    },
    BILLING_APPLEPAY: {
        code: 'billingContactInvalid',
        SRV_CUSTOMER_FIRSTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        API_ERR_FIELD_FIRSTNAME_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        API_ERR_FIELD_FIRSTNAME_MAX_VOILATED: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        SRV_CUSTOMER_LASTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        API_ERR_FIELD_LASTNAME_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        API_ERR_FIELD_LASTNAME_MAX_VOILATED: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        API_ERR_FIELD_LASTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_NAME,
        API_ERR_FIELD_COMPANYNAME_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_ADDRESS,
        API_ERR_FIELD_COMPANYNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_ADDRESS,
        API_ERR_FIELD_LINETWO_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_ADDRESS,
        API_ERR_FIELD_LINEONE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_ADDRESS_LINES,
        API_ERR_FIELD_LINEONE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_ADDRESS_LINES,
        SRV_CUSTOMER_STD_CDI002_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_ADDRESS_LINES,
        API_ERR_FIELD_CITY_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_LOCALITY,
        API_ERR_FIELD_CITY_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_LOCALITY,
        API_ERR_FIELD_STATE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_ADMINISTRATIVE_AREA,
        API_ERR_FIELD_STATE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_ADMINISTRATIVE_AREA,
        SRV_CUSTOMER_STATE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_ADMINISTRATIVE_AREA,
        API_ERR_FIELD_COUNTRY_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_COUNTRY,
        API_ERR_FIELD_COUNTRY_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_COUNTRY,
        API_ERR_FIELD_ZIP_MISSING: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_CODE,
        API_ERR_FIELD_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_CODE,
        SRV_CUSTOMER_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD_POSTAL_CODE,
    },
};
export const EXPRESS_CHECKOUT_EXPRESS_CHECKOUT_LABEL = 'NEW! Checkout Faster Next Time';
export const EXPRESS_CHECKOUT_EXPRESS_CHECKOUT_DESCRIPTION =
    'Default to these shipping & payment options on your next order';
export const allowedQueryParams = ['pTmplType'];
export const ZIP_CODE_CHANGE_CHANGE_ZIP_CODE = 'Change Zip Code';
export const ZIP_CODE_CHANGE_APPLY_ZIP_CODE = 'Apply';
export const ZIP_CODE_CHANGE_CANCEL_ZIP_CODE = 'Cancel';
export const ZIP_CODE_CHANGE_EMPTY_ZIP_CODE = 'Enter a Zip code';
export const ZIP_CODE_CHANGE_INVALID_ID_ZIP_CODE = 'Please enter a valid zip code.';
export const ZIP_CODE_CHANGE_CHANGE_ZIP_LINK = 'Change Zip';
export const ZIP_CODE_CHANGE_GENERIC_ERROR_MSG = 'Please try again';
export const GIFT_CARD_BANNER_MAG_ITEM_ADDED = 'Item added and you reached FREE shipping!';
export const GIFT_CARD_BANNER_MAG_PARTIAL_ITEM_ADDED = 'Item added';
export const GIFT_CARD_BANNER_MAG_ERROR = 'Please try again';
export const LOADER_BUTTON_PAYPAL = 'PayPal';
export const JCP = 'JCP';
export const JCPENNEY_MASTERCARD = 'JCPENNEY MASTERCARD';
export const PLCC = 'PLCC';
export const DC = 'DC';
export const GIFT_CARD = 'GIFTCARD';
export const SRV_BOPIS_STORE_DISTANT_FROM_ZIP = 'SRV_BOPIS_STORE_DISTANT_FROM_ZIP';
export const SRV_STS_STORE_DISTANT_FROM_ZIP = 'SRV_STS_STORE_DISTANT_FROM_ZIP';
export const PLACE_ORDER_ANALYTICS_ERROR = [
    'KEY_OCS_CREDIT_CARD_AUTH_FAILED',
    'SRV_OCS_CALL_CREDIT_AUTH_FAILED',
    'SRV_SESSION_TIMEOUT',
];
export const ADI_INITIATE_CHECKOUT_EXCEPTION_HANDLER = [
    'SRV_OCS_CALL_CREDIT_AUTH_FAILED',
    'SRV_CREDIT_CARD_CVV_REENTRY_REQUIRED',
];
export const BNPL_SYF = 'BNPL_SYF';
export const BNPL_TYPE_NAME = 'Synchrony Pay Later';
export const BNPL_APPLIED_ON_CHECKOUT =
    'Please note that making any changes to your cart or order total will require you to reapply for Synchrony Pay later.';
export const REJECT_ORDER = 'Reject Order';
export const SEND_TO_AGENCY = 'Send to Agency';
